import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type PersonModel from 'tio-common/models/person';
import type RouterService from '@ember/routing/router-service';
import type SessionContextService from 'tio-employee/services/session-context';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type EmployeeService from 'tio-employee/services/employee';
import type FeaturesService from 'tio-common/services/features';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type ReimaginedViewService from 'tio-employee/services/reimagined-view';
import type { ReimaginedContributionHistoryModel } from 'tio-employee/components/reimagined/production/contribution-history';

export default class AuthenticatedSlrDashboard extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;
  @service declare router: RouterService;
  @service declare employee: EmployeeService;
  @service declare features: FeaturesService;
  @service declare reimaginedData: ReimaginedDataService;
  @service declare reimaginedView: ReimaginedViewService;

  async model() {
    // This is a hack to make sure that contributions data is loaded after an doc upload for DEV-4807
    // TODO: Employee contributions data is a good candidate for updating to request manager to improve this flow
    if (this.employee.contributionsState.isFinished) {
      this.employee.contributionsState.retry();
    }
    if (this.employee.futurePayments.isFinished) {
      this.employee.futurePayments.retry();
    }
    const personId = this.sessionContext.user.person.id;
    // @ts-expect-error type models
    const person = await this.store.findRecord<PersonModel>('person', personId, {
      include: 'accounts.financial-institution,accounts.loans,accounts.postal-address',
      reload: true,
    });

    if (this.reimaginedView.isEnabled) {
      const [contributionHistory, employerContributions] = await Promise.all([
        this.reimaginedData.fetchContributionHistory(),
        this.reimaginedData.fetchEmployerContributions(),
      ]);

      const reimagined: ReimaginedContributionHistoryModel = {
        contributionHistory,
        employerContributions,
        person,
      };

      return { person, reimagined };
    }

    return person;
  }
}
